<template>
  <div>
    <!-- 최근 검색어 List -->
    <template v-if="hasHistory">
      <div class="sh-pop-sub-tit">최근 검색어
        <button class="all-delete" @click="removeAllHistory()">
          <img src="../../assets/images/search/search-icon-layer-delete-18.png" alt=""/> 전체 내역 삭제</button>
      </div><!--sh-pop-sub-tit//-->
      <div class="search-popup-scroll search-history-popup-scroll">
        <ul class="sh-pop-list01">
          <li v-for="(word, index) in historyList" :key="index">
            <a href="#" @click.prevent="goSearchDetail(word, true)">{{setReplaceWord(word)}}</a>
            <button @click="removeHistory(index)" class="recent-delete">
              <img src="../../assets/images/search/recent-delete.png" alt=""/>
            </button>
          </li>
        </ul><!--sh-pop-list01//-->
      </div><!--popup-scroll//-->
    </template>

    <!-- 최근 검색어 empty -->
    <template v-else>
      <div class="search-popup-scroll search-history-popup-scroll">
        <div class="search-empty">
<!--          <img src="../../assets/images/search/icon-error-74.png" alt=""/>-->
          <img src="../../assets/images/search/icon-error-74.png" alt=""/>
          <p>최근 검색내역이 없네요.<br/>요즘 인기있는 검색어를 추천해드릴게요.</p>
        </div>
        <div v-if="recommendList" class="search-body-tag">
          <ul class="search-body-tag-list">
            <li v-for="(tag, index) in recommendList" :key="index">
              <button @click.prevent="goListPage(tag.link)">#{{tag.text}}</button>
            </li>
          </ul>
        </div>
      </div><!--popup-scroll//-->
    </template>
  </div>
</template>

<script>
import SearchMixins from '@/mixins/search.mixin'
import { getRecommendList } from '@/common/utils/request'
import { setReplaceAll } from '@/common/utils/common'
import { CLOSE_SEARCH_POPUP_EVENT, SEARCH_HISTORY_LOCAL_STORAGE_KEY } from '@/common/resources/const'
import { PATH_NAME_SEARCH } from '@/common/resources/router.const'
export default {
  name: 'SearchHistory',
  mixins: [
    SearchMixins
  ],
  props: {
    historyList: {
      type: Array
    },
    getHistoryList: {
      type: Function
    }
  },
  data () {
    return {
      recommendList: []
    }
  },
  computed: {
    hasHistory () {
      return this.historyList.length > 0
    }
  },
  methods: {
    setReplaceWord (word) {
      return setReplaceAll(word, '@-@', '&')
    },
    setRecommendList () {
      getRecommendList().then(({ data }) => { this.recommendList = data })
    },
    removeHistory (index) {
      if (this.historyList.length > 1) {
        this.historyList.splice(index, 1)
        localStorage.setItem(SEARCH_HISTORY_LOCAL_STORAGE_KEY, this.historyList.join('&'))
      } else {
        localStorage.removeItem(SEARCH_HISTORY_LOCAL_STORAGE_KEY)
      }
      this.getHistoryList()
    },
    removeAllHistory () {
      if (confirm('최근 검색어를 모두 삭제 하시겠습니까?')) {
        localStorage.removeItem(SEARCH_HISTORY_LOCAL_STORAGE_KEY)
        this.getHistoryList()
      }
    },
    goSearchDetail (word, type) {
      const strWord = type ? this.setReplaceWord(word) : word
      this.$events.$emit(CLOSE_SEARCH_POPUP_EVENT)
      this.$router.push({
        name: PATH_NAME_SEARCH,
        query: { searchWord: strWord }
      })
    },
    goListPage (link) {
      const path = link.replace('https://m.pooq.co.kr', '')
        .replace('https://www.pooq.co.kr', '')
        .replace('https://www.wavve.com', '')
      this.$router.push(path)
      this.$events.$emit(CLOSE_SEARCH_POPUP_EVENT)
    }
  },
  created () {
    this.setRecommendList()
  }
}
</script>

<style lang="css">
.sh-pop-body .search-popup-scroll.search-history-popup-scroll{
  height: 360px;
  padding-bottom: 30px;
}
</style>
